import { axiosClient } from 'www/utils'
import type {
  ApiTownSpecialitiesParamsGet,
  ApiTownSpecialitiesResponseGet,
} from 'www/vue_components/common/TheFilters/doctors/api/apiTownSpecialities.types'

export default {
  get(params: ApiTownSpecialitiesParamsGet) {
    return axiosClient.get<ApiTownSpecialitiesResponseGet>('/api/town/specialities/', { params })
  },
}
